import { useNavigate } from "react-router-dom";
import { rewriteAdultCollectionUrl } from "../utils/anamneseVersion";

export default function Button({classes = "", url = "", label, onClick, disabled, type = "", icon = ""}) {
    const navigate = useNavigate();
    let button;
    let typeButton = "";

    const handleClick = (e) => {
        if (disabled) return;
        if (onClick) onClick(e);
        else if (url.startsWith("http://") || url.startsWith("https://")) window.open(url, "_blank", "noopener noreferrer");
        else if (url.startsWith("#")) {
            // navigate() do React Router só troca o hash da URL, não rola a
            // página até o elemento (diferente de um <a href="#id"> nativo).
            const id = url.slice(1);
            if (id) document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        else navigate(rewriteAdultCollectionUrl(url));
    };
    if (type !== "") {
        typeButton = type;
    } else {
        typeButton = "button";
    }

    // Se for submit, não define onClick (deixa o form controlar)
    const buttonProps = {
        type: typeButton,
        disabled,
        className: classes.includes("secondary")
            ? `btn ${classes}`
            : classes.includes("opt")
                ? `${classes}`
                : `btn btn-purissima ${classes}`
    };
    if (typeButton !== "submit") {
        buttonProps.onClick = handleClick;
    }

    if (classes.includes("opt")) {
        button = (
            <button {...buttonProps}><span>{label}</span> {icon !== "" && <img className="ms-1" src={icon} alt="icon" />}</button>
        );
    } else if (classes.includes("secondary")) {
        button = (
            <button {...buttonProps}>{label} {icon !== "" && <img className="ms-1" src={icon} alt="icon" />}</button>
        );
    } else {
        button = (
            <button {...buttonProps}>{icon !== "" && <img className="me-2 me-lg-3" src={icon} alt="icon" />} {label}</button>
        );
    }

    return button;
}
